// NATIVE
import React, { useEffect, useState } from 'react';

// INSTALLED
import { useSelector } from 'react-redux';
import { styled } from '@mui/material/styles';
import { Divider, Grid, TextField } from '@mui/material';
import TextAreaField from '../../formFields/TextAreaField';
import AutocompleteField from '../../formFields/autocompleteField';

// CUSTOM
import InputField from '../../formFields/InputField';
import CheckboxField from '../../formFields/checkBoxField';
import InputNumeric from '../../formFields/InputNumeric';
import DatePickerField from '../../formFields/datePickerField';
import HourPicker from '../../formFields/HourPicker';

export const CreateNovedadTurno = (props: any) => {
  const { tiponovedades_select } = useSelector((state: any) => state.tiponovedades);
  const { employee_select } = useSelector((state: any) => state.employee);

  const [employee_selected, setEmployeeSelected] = useState([]);
  const [responsble_selected, setResponsableSelected] = useState([]);

  const {
    formField: { colaborador, responsable, tipoNovedad, fechaNovedad, horaNovedad, description },
  } = props;

  useEffect(() => {}, [employee_select]);

  useEffect(() => {
    setResponsableSelected(JSON.parse(JSON.stringify(employee_select)));
  }, [employee_select]);

  const Div = styled('div')(({ theme }) => ({
    ...theme.typography.button,
    backgroundColor: 'wheat',
    padding: theme.spacing(8),
    textAlign: 'center',
  }));

  return (
    <div>
      <div>
        <Grid container>
          {/* ************ */}
          <Grid size={{ xs: 6 }} sx={{ padding: 2 }}>
            <AutocompleteField
              options={employee_select}
              name={colaborador.name}
              label={colaborador.label}
              element={colaborador.name}
            />
          </Grid>
          <Grid size={{ xs: 6 }} sx={{ padding: 2 }}>
            <AutocompleteField
              options={responsble_selected}
              name={responsable.name}
              label={responsable.label}
              element={responsable.name}
            />
          </Grid>
          {/* ************ */}

          {/* ************ */}
          <Grid size={{ xs: 6 }} sx={{ padding: 2 }}>
            <AutocompleteField
              options={tiponovedades_select}
              name={tipoNovedad.name}
              label={tipoNovedad.label}
              element={tipoNovedad.name}
            />
          </Grid>
          <Grid size={{ xs: 3 }} sx={{ padding: 2 }}>
            <DatePickerField label={fechaNovedad.label} name={fechaNovedad.name} />
          </Grid>
          <Grid size={{ xs: 3 }} sx={{ padding: 2 }}>
            <HourPicker label={horaNovedad.label} name={horaNovedad.name} />
          </Grid>
          {/* ************ */}

          {/* ************ */}
          <Grid size={{ xs: 12 }} sx={{ padding: 2 }}>
            <TextAreaField
              name={description.name}
              label={description.label}
              variant="outlined"
              fullWidth
            />
          </Grid>
          {/* ************ */}

          <Divider />
        </Grid>
      </div>
    </div>
  );
};
